import { h } from "@stencil/core";
export const MachineSelect = ({ t, prefillData, apiStore, formStore }) => {
    var _a, _b;
    const { machines } = apiStore.state;
    return (h("ux-select", { required: true, label: t("field.machine.label"), "data-validation-required--msg": t("validation.requiredField"), name: "productNo", onUxChange: (event) => {
            const machine = machines.find(({ assetId }) => assetId === event.detail.value);
            if (machine) {
                formStore.state.selectedMachineTechnology = machine.technologyId;
                return;
            }
            // eslint-disable-next-line no-console
            console.error(`Machine with id ${event.detail.value} not found`);
        }, disabled: (_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.productData) === null || _a === void 0 ? void 0 : _a.assetId }, h("option", { value: "", selected: !((_b = prefillData === null || prefillData === void 0 ? void 0 : prefillData.productData) === null || _b === void 0 ? void 0 : _b.assetId), disabled: true }, t("select.placeholder")), machines.map((machine) => {
        var _a;
        return (h("option", { key: machine.assetId, value: machine.assetId, selected: machine.assetId === ((_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.productData) === null || _a === void 0 ? void 0 : _a.assetId) }, machine.assetName, " (", machine.assetId, ")"));
    })));
};
//# sourceMappingURL=machine-select.js.map
